import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getPublishersDatatable,
  getPublishersLookups,
  getPublisherById,
  createPublisher,
  editPublisher,
  setContentEntityPublisher,
} from './thunks';
import { PublisherState } from './types';

export const name = 'publishers';

export const getPublishersDatatableAsync = createAsyncThunk(
  name + '/getPublishersDatatable',
  getPublishersDatatable
);

export const getPublishersLookupsAsync = createAsyncThunk(
  name + '/getPublishersLookups',
  getPublishersLookups
);

export const getPublisherByIdAsync = createAsyncThunk(
  name + '/getPublisherById',
  getPublisherById
);

export const createPublisherAsync = createAsyncThunk(
  name + '/createPublisher',
  createPublisher
);

export const editPublisherAsync = createAsyncThunk(
  name + '/editPublisher',
  editPublisher
);

export const setContentEntityPublisherAsync = createAsyncThunk(
  name + '/setContentEntityPublisher',
  setContentEntityPublisher
);

const initialState: PublisherState = {
  datatable: {
    data: null,
    status: 'idle',
  },
  lookups: {
    data: null,
    status: 'idle',
  },
  getPublisherById: {
    data: null,
    status: 'idle',
  },
  createPublisher: {
    data: null,
    status: 'idle',
  },
  editPublisher: {
    status: 'idle',
  },
  setContentEntityPublisher: {
    status: 'idle',
  },
};

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearPublisherById: (state) => {
      state.getPublisherById = initialState.getPublisherById;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getPublishersDatatableAsync.pending, (state) => {
        state.datatable.status = 'loading';
      })
      .addCase(getPublishersDatatableAsync.fulfilled, (state, action) => {
        state.datatable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getPublishersDatatableAsync.rejected, (state) => {
        state.datatable.status = 'failed';
      })

      .addCase(getPublishersLookupsAsync.pending, (state) => {
        state.lookups.status = 'loading';
      })
      .addCase(getPublishersLookupsAsync.fulfilled, (state, action) => {
        state.lookups = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getPublishersLookupsAsync.rejected, (state) => {
        state.lookups.status = 'failed';
      })
      .addCase(getPublisherByIdAsync.pending, (state) => {
        state.getPublisherById.status = 'loading';
      })
      .addCase(getPublisherByIdAsync.fulfilled, (state, action) => {
        state.getPublisherById = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getPublisherByIdAsync.rejected, (state) => {
        state.getPublisherById.status = 'failed';
      })
      .addCase(createPublisherAsync.pending, (state) => {
        state.createPublisher.status = 'loading';
      })
      .addCase(createPublisherAsync.fulfilled, (state, action) => {
        state.createPublisher = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(createPublisherAsync.rejected, (state) => {
        state.createPublisher.status = 'failed';
      })
      .addCase(editPublisherAsync.pending, (state) => {
        state.editPublisher.status = 'loading';
      })
      .addCase(editPublisherAsync.fulfilled, (state) => {
        state.editPublisher.status = 'idle';
      })
      .addCase(editPublisherAsync.rejected, (state) => {
        state.editPublisher.status = 'failed';
      })
      .addCase(setContentEntityPublisherAsync.pending, (state) => {
        state.setContentEntityPublisher.status = 'loading';
      })
      .addCase(setContentEntityPublisherAsync.fulfilled, (state) => {
        state.setContentEntityPublisher.status = 'idle';
      })
      .addCase(setContentEntityPublisherAsync.rejected, (state) => {
        state.setContentEntityPublisher.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
